import { motion } from "framer-motion";
import { Eyebrow, SerifH } from "./shared";
import { WEAR_TILES } from "../data/content";

export function WearThreeWays() {
  return (
    <section id="wear" data-testid="wear-three" className="bg-[#F4EDE2] text-[#0C111C]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20 py-24 md:py-32">
        <Eyebrow>One jellaba · three lives</Eyebrow>
        <SerifH className="mt-4" size="clamp(32px, 3.6vw, 56px)">
          Wear it three ways.
        </SerifH>
        <div className="mt-14 grid md:grid-cols-3 gap-6 md:gap-8">
          {WEAR_TILES.map((t, i) => (
            <motion.div
              key={t.context}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className="group"
            >
              <div className="relative overflow-hidden aspect-[3/4]">
                <img
                  src={t.image}
                  alt={t.context}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-[1.05]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0C111C] via-[#0C111C]/40 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6 text-[#F4EDE2]">
                  <p
                    className="text-[10px] tracking-[0.24em] uppercase text-[#C8A96A]"
                    style={{ fontFamily: "Inter, sans-serif" }}
                  >
                    {t.context}
                  </p>
                  <p className="mt-2 text-lg" style={{ fontFamily: "Fraunces, serif" }}>
                    {t.sub}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
